<template>
  <h3>Home Page</h3>
  <UserPage />
</template>

<script setup>
import UserPage from '@/components/UserPage.vue';
</script>